import React from "react";

import b64 from "base-64";
import { useForm } from "react-hook-form";
import { Link, useHistory } from "react-router-dom";
import { AiTwotoneEye, AiTwotoneEyeInvisible } from "react-icons/ai";

import { paletas } from "../../styles/theme";
import { BgMais, Wrapper, Erro } from "./styles";
import { ILogin } from "../../models";
import { useApp } from "../../contexts";
import { LogarUsuario } from "../../servicos";
import { Loading, Mensagem } from "../../componentes";

export default function Login() {
  const { setUsuarioAutenticado } = useApp();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();
  const history = useHistory();
  const [loading, setLoading] = React.useState(false);
  const [type, setType] = React.useState("password");
  const [mensagem, setMensagem] = React.useState("");

  // Verifica dados salvos no localstorage
  React.useEffect(() => {
    const usuarioSalvoLocalStorage = localStorage.getItem(
      "@batalha-dev/usuario"
    );

    if (usuarioSalvoLocalStorage) {
      let dadosLocalUsuario = JSON.parse(usuarioSalvoLocalStorage);
      setValue("email", dadosLocalUsuario.email);
    }
  }, [setValue]);

  const onSubmit = async (data: ILogin) => {
    const senhaB64 = b64.encode(data.senha);
    try {
      setLoading(true);

      const dadosAcesso = {
        email: data.email,
        senha: senhaB64,
      };

      const retorno: any = await LogarUsuario(dadosAcesso);

      if (retorno.data.success) {
        localStorage.setItem(
          "@batalha-dev/autenticado",
          JSON.stringify(retorno.data)
        );
        setUsuarioAutenticado(retorno.data);
        history.push("/");
        setValue("email", "");
        setValue("senha", "");
      } else {
        setMensagem(`Usuário ou senha está incorreta!`);
        return;
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setMensagem("Lamento, falha na comnunicação com o servidor!");
    } finally {
      setLoading(false);
      setValue("checkbox", "");
      setTimeout(() => {
        setMensagem("");
      }, 5000);
    }
  };

  const mostrarSenha = () => {
    if (type === "password") {
      setType("text");
    } else {
      setType("password");
    }
  };

  return (
    <Wrapper>
      <BgMais />
      <h2>LOGIN</h2>
      <form onSubmit={handleSubmit(onSubmit)}>
        <input
          {...register("email", { required: true })}
          placeholder="E-mail"
        />
        {errors.email && (
          <Erro>
            <span>O campo email é obrigatório!</span>
          </Erro>
        )}

        <div className="container-password">
          <input
            {...register("senha", { required: true })}
            placeholder="Senha"
            type={type}
          />
          <button type="button" onClick={mostrarSenha}>
            {type === "password" ? <AiTwotoneEyeInvisible /> : <AiTwotoneEye />}
          </button>
        </div>
        {errors.senha && (
          <Erro>
            <span>O campo senha é obrigatório!</span>
          </Erro>
        )}

        <div className="container-captcha">
          <div>
            <input
              type="checkbox"
              id="valido"
              {...register("checkbox", { required: true })}
            />
            <label htmlFor="valido">
              <span></span>
              Não sou um robô
            </label>
          </div>
        </div>
        <div className="container-captcha">
          {errors.checkbox && (
            <Erro>
              <span>Mostre-nos que você não é um robô!</span>
            </Erro>
          )}
        </div>

        <Loading cor={paletas.DarkOrange} loading={loading}>
          <input className="input-submit" type="submit" value="ENTRAR" />
        </Loading>
      </form>
      <Link to="/cadastro">Cadastre-se</Link>
      <Link to="/recuperar-senha">Recuperar Senha</Link>
      {mensagem ? <Mensagem tipo="erro" frase={mensagem} /> : null}
    </Wrapper>
  );
}
